/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Minutes_TextInputs */

const en_minutes_text = /** @type {(inputs: Minutes_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mins`)
};

const ar_minutes_text = /** @type {(inputs: Minutes_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`د`)
};

const de_minutes_text = /** @type {(inputs: Minutes_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Min.`)
};

const es_minutes_text = /** @type {(inputs: Minutes_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`min`)
};

const fr_minutes_text = /** @type {(inputs: Minutes_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`min`)
};

const it_minutes_text = /** @type {(inputs: Minutes_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`min`)
};

const ja_minutes_text = /** @type {(inputs: Minutes_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分`)
};

const ko_minutes_text = /** @type {(inputs: Minutes_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`분`)
};

const pt_br_minutes_text = /** @type {(inputs: Minutes_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`min`)
};

const ru_minutes_text = /** @type {(inputs: Minutes_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`мин`)
};

const th_minutes_text = /** @type {(inputs: Minutes_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`นาที`)
};

const tr_minutes_text = /** @type {(inputs: Minutes_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dk`)
};

const zh_cn_minutes_text = /** @type {(inputs: Minutes_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分钟`)
};

const zh_tw_minutes_text = /** @type {(inputs: Minutes_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分鐘`)
};

/**
* | output |
* | --- |
* | "mins" |
*
* @param {Minutes_TextInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const minutes_text = /** @type {((inputs?: Minutes_TextInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Minutes_TextInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_minutes_text(inputs)
	if (locale === "ar") return ar_minutes_text(inputs)
	if (locale === "de") return de_minutes_text(inputs)
	if (locale === "es") return es_minutes_text(inputs)
	if (locale === "fr") return fr_minutes_text(inputs)
	if (locale === "it") return it_minutes_text(inputs)
	if (locale === "ja") return ja_minutes_text(inputs)
	if (locale === "ko") return ko_minutes_text(inputs)
	if (locale === "pt_br") return pt_br_minutes_text(inputs)
	if (locale === "ru") return ru_minutes_text(inputs)
	if (locale === "th") return th_minutes_text(inputs)
	if (locale === "tr") return tr_minutes_text(inputs)
	if (locale === "zh_cn") return zh_cn_minutes_text(inputs)
	return zh_tw_minutes_text(inputs)
});